<template>
  <b-container id="passages_pc_course" v-if="passages.list_parcours">
    <b-row>
      <b-col md="12">
        <div>
          <b-tabs content-class="mt-3">
            <b-tab title="Affichage par parcours" active>
              <p>Au départ d'une course, les partants passeront en coureurs attendus. Une ligne verte indique que tous les coureurs attendus ont atteint le point de passage, une ligne rouge indique que des coureurs sont encore attendus</p>
              <div v-for="(parcours, index) in passages.list_parcours.list" :key="index">
                <SecuriteParcours :parcours="parcours"></SecuriteParcours>
              </div>
            </b-tab>
            <b-tab title="Affichage par point">
              <p>
                Au départ d'une course, les statistiques de coureurs pour chacun des points du parcours seront répercutées sur le point associé. Une ligne verte indique que tous les coureurs attendus sont passés par la box, une ligne rouge indique
                que des coureurs sont encore attendus
              </p>

              <div v-for="(box, index_box) in passages.list_box" :key="index_box">
                <SecuriteBox :box="box" :name="index_box"></SecuriteBox>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import SecuriteParcours from "@/components/Live_tab/PCCourse/SecuriteParcours.vue";
import SecuriteBox from "@/components/Live_tab/PCCourse/SecuriteBox.vue";
export default {
  components: { SecuriteParcours, SecuriteBox },
  data() {
    return {
      passages: {},
    };
  },
  methods: {
    async loadPassages() {
      var _this = this;
      await axios.get(this.$store.state.base_url + "/pc_course/passages/get.php?id=" + this.$store.state.module.id).then(function (response) {
        _this.passages = response.data;
      });
    },
    countdownRefresh() {
      if (!this.$store.state.live_en_cours) {
        this.$store.commit("clearRefreshIntervals");
        return;
      }
      var _this = this;
      var intervalObject = setInterval(function () {
        _this.$store.commit("clearRefreshIntervals");
        _this.loadPassages();
        _this.countdownRefresh();
      }, 30000);
      this.$store.state.refreshIntervals.push(intervalObject);
    },
  },
  async created() {
    this.$store.commit("clearRefreshIntervals");
    await this.loadPassages();
    this.countdownRefresh();
  },
};
</script>

<style lang="scss" scoped>
</style>